import {
  MIN_CLIP_MS,
  MAX_CLIP_MS,
  WINDOW_MS,
} from './constants';

// The trip, cut at "now" when it ended a moment ago relative to a stale clock.
export const getTripBounds = (trip, nowMs) => ({
  start: trip.startMs,
  end: Math.min(trip.endMs, nowMs),
});

// A window of up to 5 minutes that starts at `startMs` and stays inside `bounds`.
export const getWindow = (startMs, bounds) => {
  const length = Math.max(0, Math.min(WINDOW_MS, bounds.end - bounds.start));
  let start = Math.max(startMs, bounds.start);
  if (start + length > bounds.end) start = bounds.end - length;
  return { start, end: start + length };
};

export const shiftWindow = (window, direction, bounds) =>
  getWindow(window.start + direction * WINDOW_MS, bounds);

export const canShiftWindow = (window, direction, bounds) => {
  if (direction < 0) return window.start > bounds.start;
  return window.end < bounds.end;
};

export const defaultRange = (window) => ({
  start: window.start,
  end: Math.min(window.start + MIN_CLIP_MS, window.end),
});

// Places a range of `lengthMs` that starts at `startMs`, sliding it back when it would pass the window end.
export const fitRange = (startMs, lengthMs, window) => {
  const length = Math.max(0, Math.min(lengthMs, window.end - window.start));
  let start = Math.max(startMs, window.start);
  if (start + length > window.end) start = window.end - length;
  return { start, end: start + length };
};

export const centerRangeOn = (markerMs, range, window) =>
  fitRange(markerMs - (range.end - range.start) / 2, range.end - range.start, window);

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

// The clip cannot be shorter than a minute (or than the window, when a short trip leaves less room).
const minGap = (window) => Math.min(MIN_CLIP_MS, window.end - window.start);

// Moves one handle by `deltaMs`; handles stay inside the window and never get closer than one minute.
export const moveHandle = (range, handle, deltaMs, window) => {
  if (handle === 'start') {
    return { ...range, start: clamp(range.start + deltaMs, window.start, range.end - minGap(window)) };
  }
  return { ...range, end: clamp(range.end + deltaMs, range.start + minGap(window), window.end) };
};

export const setRangeEdge = (range, edge, ms, window) => {
  if (!Number.isFinite(ms)) return range;
  return moveHandle(range, edge, ms - range[edge], window);
};

export const validateRange = (range, window) => {
  if (!range || !Number.isFinite(range.start) || !Number.isFinite(range.end)) return 'missing';
  if (range.start < window.start || range.end > window.end) return 'outside';
  const length = range.end - range.start;
  if (length < MIN_CLIP_MS) return 'tooShort';
  if (length > MAX_CLIP_MS) return 'tooLong';
  return null;
};
